import React from "react";
import { SectionLabel, Reveal, CTAButton } from "@/lib/uiHelpers";
import { GALLERY } from "@/constants/landingCopy";

function GalleryTile({ photo }) {
  return (
    <div
      className={`group relative overflow-hidden rounded-2xl h-full ${photo.span ? "min-h-[260px] lg:min-h-[540px]" : "min-h-[260px]"}`}
      style={{ border: "1px solid rgba(255,255,255,0.1)" }}
    >
      <img
        src={photo.src}
        alt={photo.caption}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />
      <div
        className="absolute inset-x-0 bottom-0 p-4"
        style={{ background: "linear-gradient(0deg, rgba(16,26,46,0.92), transparent)" }}
      >
        <span className="font-body text-sm font-medium text-white">{photo.caption}</span>
      </div>
    </div>
  );
}

export default function Gallery() {
  return (
    <section className="section-pad" style={{ backgroundColor: "#1A2B4A" }}>
      <div className="container-max">
        <Reveal className="text-center max-w-2xl mx-auto">
          <SectionLabel>Real Maui Installs</SectionLabel>
          <h2 className="font-head font-extrabold text-3xl md:text-5xl text-white">
            Done Right, All Over the Island
          </h2>
          <p className="font-body mt-4 text-base md:text-lg text-white/75">
            Real systems on real Maui homes &mdash; from rooftop solar with an ocean view to clean,
            code-compliant battery backups.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {GALLERY.map((photo, i) => (
            <Reveal
              key={photo.src}
              delay={Math.min(i * 0.06, 0.3)}
              className={photo.span ? "sm:col-span-2 lg:row-span-2" : ""}
            >
              <GalleryTile photo={photo} />
            </Reveal>
          ))}
        </div>

        <div className="mt-10 text-center">
          <CTAButton testId="gallery-cta" variant="gold" className="w-full sm:w-auto">
            &rarr; Get My Maui Install &mdash; Book My Call
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
